import { type PropsWithChildren } from 'react';

import { Threshold } from '../../core/components/sparkline-display/slots/Threshold.js';
import { YAxis } from '../../core/components/sparkline-display/slots/YAxis.js';
import type { SparklineProps } from '../../core/components/sparkline-display/types/sparkline-props.js';
import { EmptyStateSlot } from '../../core/slots/chart-states/EmptyStateSlot.js';
import { ErrorStateSlot } from '../../core/slots/chart-states/ErrorStateSlot.js';

/**
 * Slot props for the Sparkline component within SingleValue.
 * @public
 */
export type SingleValueSparklineProps = PropsWithChildren<
  Omit<SparklineProps, 'loading'>
>;

const SparklineRoot = (props: PropsWithChildren<SingleValueSparklineProps>) =>
  null;

/**
 * Slot for the Sparkline component
 * @public
 */
export const Sparkline = Object.assign(SparklineRoot, {
  Threshold,
  YAxis,
  EmptyState: EmptyStateSlot,
  ErrorState: ErrorStateSlot,
});

(Sparkline as typeof Sparkline & { displayName: string }).displayName =
  'SingleValue.Sparkline';
